/**
 * Represents the detail structure of the hp6Change event.
 */

/**
 * The interface which represents the expected props for the ChangeEventDetail class
 */
interface ChangeEventDetailProps {
  /**
   * The original event that triggered the change
   */
  originalEvent?: Event;

  /**
   * The value after the change
   */
  value: string | undefined;
}

/**
 * Default values for constructor props
 */
const defaults: ChangeEventDetailProps = {
  originalEvent: undefined,
  value: undefined,
};

/**
 * When a value changes we use this detail to pass the value
 */
export class ChangeEventDetail {
  /**
   * The original event that triggered the change
   */
  originalEvent: Event | undefined;

  /**
   * The value after the change
   */
  value: string | undefined;

  /**
   * constructor()
   *
   * @param ChangeEventDetailProps The props to initialize the class with
   */
  constructor(props: ChangeEventDetailProps = defaults) {
    this.originalEvent = props.originalEvent;
    this.value = props.value;
  }
}

/**
 * The implementing class must emit a hp6Change event
 */

/**
 * @Event() hp6Change: EventEmitter<ChangeEventDetail>;
 *
 * someClassMethod() {
 *    this.hp6Change.emit(
 *      new ChangeEventDetail({ value: someValue })
 *   );
 * }
 *
 */
